<div class="text-center d-flex flex-column align-items-center">
  <i nz-icon [nzType]="iconType" class="f-80"></i>
  <span class="no-results-title mb-2">{{ title | cxTranslate }}</span>
  <span class="no-results-description" *ngIf="description">{{ description }}</span>
</div>
